import { Ed25519KeyIdentity } from '@icp-sdk/core/identity'
import { importKeypairWallet } from '@plug-core/handlers/walletActions/wallet'
import { logger } from '@plug-core/logger'
import { setDefaultWalletName } from '@plug-core/utils/setDefaultWalletName'
import { useFindTokensProvider } from '@providers/FindTokensProvider'
import * as bip39 from '@scure/bip39'
import { Button, Text, Textarea } from '@ui'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const WalletImportStoic = () => {
  const [seedPhrase, setSeedPhrase] = useState<string>()
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()
  const { findTokens } = useFindTokensProvider()
  const { t } = useTranslation()

  const performImport = useCallback(() => {
    if (!seedPhrase) return

    setIsLoading(true)

    const seed = bip39.mnemonicToSeedSync(seedPhrase.trim())
    let seedArray = Array.from(seed)
    seedArray = seedArray.splice(0, 32)
    const identity = Ed25519KeyIdentity.generate(new Uint8Array(seedArray))

    importKeypairWallet(JSON.stringify(identity.toJSON()), 'ed25519')
      .then(async (wallet) => {
        await findTokens(wallet.principal)
        await setDefaultWalletName(wallet.principal)
        navigate(-2)
      })
      .catch(logger.debug)
  }, [seedPhrase])

  return (
    <div className="mb-3 flex flex-col gap-4">
      <Textarea
        value={seedPhrase}
        onChange={(e) => setSeedPhrase(e.target.value)}
        placeholder={t('importWalletStoic.seedPhrasePlaceholder')}
        aria-label={t('importWalletStoic.seedPhrasePlaceholder')}
        rows={4}
      />
      <Text variant="body-s" tone="fg-2">
        {t('importWalletStoic.subbaccountWarning')}
      </Text>
      <Text variant="body-s" tone="fg-2">
        {t('importWalletStoic.seedPhraseInfo')}
      </Text>
      <Button
        onClick={performImport}
        fullWidth
        variant="primary"
        loading={isLoading}
        disabled={isLoading}
      >
        {t('importWalletStoic.import')}
      </Button>
    </div>
  )
}

export default WalletImportStoic
